import styled from "styled-components";

export const LeftButtonSection = styled.div`
  width: 100%;
  min-width: 0;

  @media (min-width: 600px) {
    width: auto;
    flex: 0 1 auto;
  }
`;

export const ToolbarControls = styled.div`
  display: flex;
  flex: 1 1 100%;
  min-width: 0;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;

  @media (min-width: 600px) {
    flex: 1 1 360px;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const FilterControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  min-width: 0;

  @media (min-width: 600px) {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    width: auto;
  }
`;

export const FilterInputWrapper = styled.div`
  width: 100%;
  min-width: 0;

  @media (min-width: 600px) {
    width: 320px;
  }

  @media (min-width: 900px) {
    width: 340px;
  }
`;

export const SearchInputWrapper = styled.div`
  width: 100%;
  min-width: 0;

  @media (min-width: 600px) {
    width: 220px;
  }

  @media (min-width: 900px) {
    width: 260px;
  }
`;

export const TableWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;

  @media (max-width: 599px) {
    padding-left: 12px;
    padding-right: 12px;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 65px;
`;

export const FilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 20px 10px;
  flex-wrap: wrap;
  border-bottom: 1px solid #f0f0f0;
`;

export const FilterLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #888;
  white-space: nowrap;

  @media (min-width: 600px) {
    padding-top: 4px;
  }
`;
